// extracted by mini-css-extract-plugin
export default {"bottomSlide":"index_bottomSlide_qhdae","activityBox":"index_activityBox_vS3t9","activityImage":"index_activityImage_Y0JV2"};